import { createApp } from 'vue';
import EventListCalendarBlock from './EventListCalendarBlock.vue';
import { initExpandableInfoIcon } from './expandable-info-icon';

const BLOCK_SELECTOR = '[data-event-list-calendar-block]';
const CONFIG_SELECTOR = '[data-event-list-calendar-config]';
const MOUNT_SELECTOR = '[data-event-list-calendar-mount]';

const mountedBlocks = new Map();
let observer = null;

/**
 * Mount Event List / Calendar Vue islands inside Gutenberg content.
 */
export function initEventListCalendarBlocks(router, pinia) {
  mountEventListCalendarBlocks(router, pinia);

  initExpandableInfoIcon({
    buttonSelector: '.b-calendar__info-button',
    titleSelector: '.b-calendar__title.has-info',
    showLabel: 'Show calendar information',
    hideLabel: 'Hide calendar information',
  });

  if (observer) {
    return;
  }

  observer = new MutationObserver(() => {
    unmountRemovedBlocks();
    mountEventListCalendarBlocks(router, pinia);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function mountEventListCalendarBlocks(router, pinia) {
  document.querySelectorAll(BLOCK_SELECTOR).forEach(block => {
    if (mountedBlocks.has(block)) {
      return;
    }

    const mountTarget = block.querySelector(MOUNT_SELECTOR);
    const config = configForBlock(block);
    if (!mountTarget || !config) {
      return;
    }

    const app = createApp(EventListCalendarBlock, { config });
    app.use(router);
    if (pinia) {
      app.use(pinia);
    }
    app.mount(mountTarget);

    mountedBlocks.set(block, app);
  });
}

function unmountRemovedBlocks() {
  mountedBlocks.forEach((app, block) => {
    if (document.documentElement.contains(block)) {
      return;
    }

    app.unmount();
    mountedBlocks.delete(block);
  });
}

function configForBlock(block) {
  const configElement = block.querySelector(CONFIG_SELECTOR);
  if (!configElement) {
    return null;
  }

  try {
    return JSON.parse(configElement.textContent || '{}');
  } catch (error) {
    console.error('Event List / Calendar block config is invalid.', error);

    return null;
  }
}
